import styled from 'styled-components';

const color = '#bdbdbd';

interface ItemBoxStyleProps {
  isEmpty: boolean;
}

interface HorizontalLineStyleProps {
  width: string | number;
}

interface LineHeightStyleProps {
  height: string | number;
}

export const Container = styled.div`
  position: relative;
  width: 100%;
  padding: 20px 32px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ItemContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const ItemBox = styled.div<ItemBoxStyleProps>`
  padding: 0 10px;
  max-width: ${({ isEmpty }) => (isEmpty ? '22px' : '100px')};
  height: ${({ isEmpty }) => (isEmpty ? '22px' : '28px')};
  border: 1px solid ${color};
  border-radius: 5px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ItemBoxText = styled.p`
  cursor: default;
  margin-bottom: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 11px;
  color: #607d8b;
  margin: 5px 0;
`;

export const HorizontalLine = styled.div<HorizontalLineStyleProps>`
  align-self: center;
  background-color: ${color};
  width: ${({ width }) => `${width}px`};
  height: 1px;
`;

export const ParentescoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const VerticalLineContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const VerticalLineTop = styled.div<LineHeightStyleProps>`
  border-top: 1px solid ${color};
  border-top-left-radius: 6px;
  border-left: 1px solid ${color};
  width: 32px;
  height: ${({ height }) => `${height}px`};
`;

export const VerticalLineBottom = styled.div<LineHeightStyleProps>`
  border-bottom: 1px solid ${color};
  border-bottom-left-radius: 6px;
  border-left: 1px solid ${color};
  width: 32px;
  height: ${({ height }) => `${height}px`};
`;

export const Span = styled.span<LineHeightStyleProps>`
  flex: 1;
  width: 100%;
  min-height: ${({ height }) => `${height}px`};
`;
